import { AkinatorCompletion } from 'types/suggestions';

type ShouldShowAkinatorCompletionsParams = {
  searchQuery: string;
  completions: AkinatorCompletion[] | null | undefined;
  isKzDomain: boolean;
  isAkinatorEnabled: boolean;
};

export const shouldShowAkinatorCompletions = ({
  searchQuery,
  completions,
  isKzDomain,
  isAkinatorEnabled,
}: ShouldShowAkinatorCompletionsParams): boolean => {
  const akinatorCompletionsExist = (completions?.length ?? 0) > 0;
  const isDefaultList = searchQuery === '';

  return !isDefaultList && !isKzDomain && akinatorCompletionsExist && isAkinatorEnabled;
};
